<div class="addContainer">
    <div class="modalHeader">
        <div class="editRowModal">
            <div class="modalHeader clearfix">
                <div class="modalHeader clearfix">
                    <img src="../../../../../assets/images/emtec.png" alt="avatar" />
                    <div class="modal-about">
                        <div class="font-weight-bold p-t-5 ms-2 me-2 font-17">
                            Edit Outstation
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <form class="register-form m-4" [formGroup]="updatOutstationForm">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Outstation Name</mat-label>
                        <input matInput formControlName="outstationName" required />
                        <mat-error *ngIf="updatOutstationForm.get('outstationName').hasError('required')">
                            Outstation name is required
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>OutStation Location</mat-label>
                        <input matInput formControlName="outstationLocation" required />
                        <mat-error *ngIf="updatOutstationForm.get('outstationLocation').hasError('required')">
                            Outstation Location is required
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                    <div class="example-button-row" align="end">
                        <button mat-raised-button color="primary" [disabled]="!updatOutstationForm.valid" (click)="updatOutstation()">
                            Update
                        </button>
                        <button mat-raised-button color="warn" (click)="onClick()" tabindex="-1">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>